var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C4.47692 20 0 15.5231 0 10C0 4.47692 4.47692 0 10 0C15.5231 0 20 4.47692 20 10C20 15.5231 15.5231 20 10 20ZM10 2C5.75231 2 2 5.74539 2 9.99308C2 14.2408 5.75231 18 10 18C14.2485 18 18 14.2477 18 10C18 5.75231 14.2485 2 10 2ZM13.49 12.7192L12.71 13.4992C12.5669 13.6423 12.3346 13.6423 12.1908 13.4992L9.98308 11.2915L7.77538 13.4992C7.63154 13.6423 7.4 13.6423 7.25615 13.4992L6.47615 12.7192C6.33308 12.5762 6.33308 12.3438 6.47615 12.2L8.68462 9.99308L6.47615 7.78539C6.33308 7.64154 6.33308 7.40923 6.47615 7.26538L7.25615 6.48615C7.4 6.34231 7.63154 6.34231 7.77538 6.48615L9.98308 8.69385L12.1908 6.48615C12.3346 6.34231 12.5669 6.34231 12.71 6.48615L13.49 7.26538C13.6331 7.40923 13.6331 7.64154 13.49 7.78539L11.2815 9.99308L13.49 12.2C13.6331 12.3438 13.6331 12.5769 13.49 12.7192Z",
    fill: "#FC5A5A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectIcon);
export default __webpack_public_path__ + "static/media/rejectIcon.070075959d5be858042f9bfdc99bd57c.svg";
export { ForwardRef as ReactComponent };